export enum FormulaType {
  EQUAL = 'equal',
  MIN_MAX = 'min-max',
  MIN_MAX_ADVANCED = 'min-max-advanced',
  HORIZONTAL_TANK_LEVEL = 'horizontal-tank-level',
  LINEARIZATION = 'linearization',
  SPHERICAL_TANK_LEVEL = 'spherical-tank-level',
  SLOPE_SHIFT = 'slope-shift',
  CONSTANT = 'constant',
  OLD_CONSUMPTION_FOR_PG = 'OLD_consumption-for-pg',
  CONSUMPTION_FOR_PG = 'consumption-for-pg',
  SHORTFALL = 'shortfall',
  AUTONOMY_FOR_PG = 'autonomy-for-pg',
  SUM = 'sum',
  AVERAGE = 'avg',
  AVERAGE_ADVANCED = 'avg-advanced'
}

export enum SrcVariableType {
  DEVICE_VARIABLE = 'device-variable',
  ASSET_VARIABLE = 'asset-variable',
  NONE = 'none'
}

// Maps a FormulaType to the label shown in the UI. Backend still receives the original enum value.
export const FORMULA_TYPE_DISPLAY_NAMES: Partial<Record<FormulaType, string>> = {
  [FormulaType.LINEARIZATION]: 'horizontal-for-bulk-advanced',
  [FormulaType.HORIZONTAL_TANK_LEVEL]: 'horizontal-for-bulk',
  [FormulaType.SPHERICAL_TANK_LEVEL]: 'spherical-for-bulk'
};
